<template>
    <div class="dashboard-employee-card-background">

        <b-button class="dashboard-employee-card-button-style" v-b-toggle.accordion-failed-invoices>
            <div class="float-right">
                <span class="mr-2 badge badge-secondary">{{ failedInvoicesCount }}</span>
                <i v-if="this.open" class="fa fa-chevron-right" aria-hidden="true"></i>
                <i v-else class="fa fa-chevron-down" aria-hidden="true"></i>
            </div>
            {{ uLang('app.failed_invoices') }}
        </b-button>

        <b-collapse class="dashboard-employee-card-collapse" id="accordion-failed-invoices">
            <rea-loader :loading="loading"></rea-loader>
            <table class="failed-invoices-table table mt-4">
                <tr v-if="failedInvoices.length === 0">
                    <td colspan="4">{{ uLang('app.empty_table') }}</td>
                </tr>
                <tr v-if="failedInvoices.length > 0">
                    <th>{{ uLang('app.subject') }}</th>
                    <th>{{ uLang('app.message') }}</th>
                    <th>{{ uLang('app.extra') }}</th>
                    <th></th>
                    <th></th>
                </tr>
                <tr v-for="invoice in failedInvoices">
                    <td>
                        {{ invoice.subject }}
                    </td>
                    <td>
                        {{ invoice.body }}
                    </td>
                    <td>
                        {{ invoice.guessed_error }}
                    </td>
                    <td>
                        <router-link
                            :to="invoice.route_to"
                            v-if="invoice.route_to && invoice.route_text"
                        >
                            {{ invoice.route_text }}
                        </router-link>
                    </td>
                    <td>
                        <button :disabled="invoice.retried == true" class="btn btn-brand btn-block"
                                @click.prevent="retry(invoice.id)">
                            <i class="fa fa-lg fa-recycle"></i> {{ uLang('app.try_again') }}
                        </button>
                    </td>
                    <td>
                        <button v-if="!invoice.retried" class="btn btn-outline-danger btn-block"
                                @click.prevent="hide(invoice.id)">
                            <i class="fa fa-lg fa-eye-slash"></i> {{ uLang('app.hide') }}
                        </button>
                        <button v-else class="btn btn-outline-primary btn-block"
                                @click.prevent="restore(invoice.id)">
                            <i class="fa fa-lg fa-eye"></i> {{ uLang('app.restore') }}
                        </button>
                    </td>
                </tr>
            </table>
        </b-collapse>
    </div>
</template>
<script>
import {ReaLoader} from '~/components/helpers'
import {SuccessAlert, ErrorAlert, DestroyAlert} from '~/Swals'

export default {
    name: 'FailedInvoices',

    components: {
        ReaLoader
    },

    data() {
        return {
            failedInvoices: [],
            loading: true,
            open: false,
            failedInvoicesCount: 0,
        }
    },

    async created() {
        this.$root.$on('collapse::toggle', async (target, show) => {
            if (target == 'accordion-failed-invoices') {
                this.open = !this.open;
            }
        });
        this.$root.$on('collapse::toggle::state', async (target, show) => {
            if (target == 'accordion-failed-invoices') {
                if (show == true && this.loading == true) {
                    const { data } = await window.axios.get(route("dashboard.failed-invoices"));
                    this.failedInvoices = data.trajectory_administrator.failed_invoices;
                    this.loading = false;
                }
            }
        });

        const { data } = await window.axios.get(route("dashboard.failed-invoices.count"));
        this.failedInvoicesCount = data.failed_invoices_count.count;
    },

    methods: {
        retry(invoiceId) {
            window.axios.put(route('failed-invoices.retry', {invoice: invoiceId}), {})
                .then(({data}) => {
                    if ($getIfExists(data, 'message') === 'success') {
                        new SuccessAlert({'text': uLang('app.successfully_retried')}).show()
                    }

                    // Disable button
                    this.failedInvoices.map((invoice) => {
                        if (invoice.id == invoiceId) {
                            invoice.retried = true;
                        }
                    })
                }).catch((error) => {
                new ErrorAlert({'text': uLang('app.please_notify_administrator')}).show()
            })
        },
        hide(invoiceId) {
            new DestroyAlert({entity: this.lang('app.failed_invoices')}).show().then(() => {
                window.axios.put(route('failed-invoices.hide', {invoice: invoiceId}), {})
                    .then(({data}) => {
                        if ($getIfExists(data, 'message') === 'success') {
                            new SuccessAlert({'text': uLang('app.successfully_hidden')}).show()
                        }

                        // Disable button
                        this.failedInvoices.map((invoice) => {
                            if (invoice.id == invoiceId) {
                                invoice.retried = true;
                            }
                        })
                    }).catch((error) => {
                    new ErrorAlert({'text': uLang('app.please_notify_administrator')}).show()
                })
            })
        },
        restore(invoiceId) {
            window.axios.put(route('failed-invoices.restore', {invoice: invoiceId}), {})
                .then(({data}) => {
                    if ($getIfExists(data, 'message') === 'success') {
                        new SuccessAlert({'text': uLang('app.successfully_restored')}).show()
                    }

                    // Disablen't button
                    this.failedInvoices.map((invoice) => {
                        if (invoice.id == invoiceId) {
                            invoice.retried = false;
                        }
                    })
                }).catch((error) => {
                new ErrorAlert({'text': uLang('app.please_notify_administrator')}).show()
            })
        }
    }
    }
</script>
<style lang="scss">
    table.failed-invoices-table {
        tr:first-child {
            td, th {
                text-align: left;
                border-top: none;
            }
        }
        td, th {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }
    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
        min-height: 75px;
    }
</style>
